import React from "react";
import { Box } from "@chakra-ui/react";
import { useColorMode } from "@chakra-ui/react";

const DirectLogo: React.FC = () => {
  const { colorMode } = useColorMode();
  
  return (
    <Box>
      {colorMode === "dark" ? (
        <img 
          src="/logos/LearnYourselfHomepageLogo_white.png" 
          alt="LearnYourself" 
          style={{
            height: "45px",
            width: "auto",
            maxHeight: "45px",
            maxWidth: "200px",
            objectFit: "contain"
          }}
        />
      ) : (
        <img 
          src="/logos/LearnYourselfHomepageLogo.png" 
          alt="LearnYourself" 
          style={{
            height: "45px",
            width: "auto",
            maxHeight: "45px",
            maxWidth: "200px",
            objectFit: "contain"
          }}
        />
      )}
    </Box>
  );
};

export default DirectLogo;